var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinityPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33203L7.13201 4.80269C6.9627 5.47993 6.87804 5.81855 6.70173 6.09409C6.54578 6.33782 6.33879 6.5448 6.09507 6.70075C5.81953 6.87707 5.48091 6.96172 4.80367 7.13103L1.33301 7.9987L4.80367 8.86636C5.48091 9.03567 5.81953 9.12033 6.09507 9.29664C6.33879 9.4526 6.54578 9.65958 6.70173 9.90331C6.87805 10.1788 6.9627 10.5175 7.13201 11.1947L7.99968 14.6654L8.86734 11.1947C9.03665 10.5175 9.1213 10.1788 9.29762 9.90331C9.45357 9.65958 9.66056 9.4526 9.90428 9.29664C10.1798 9.12033 10.5184 9.03567 11.1957 8.86636L14.6663 7.9987L11.1957 7.13103C10.5184 6.96172 10.1798 6.87707 9.90428 6.70075C9.66056 6.5448 9.45357 6.33782 9.29762 6.09409C9.1213 5.81855 9.03665 5.47993 8.86734 4.80269L7.99967 1.33203Z",
    stroke: "#3F4FF8",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityPlanIcon);
export default __webpack_public_path__ + "static/media/infinity-plan-icon.cce860978ced8623641f6954c737ce93.svg";
export { ForwardRef as ReactComponent };